import { useCalcOp } from 'Contexts/CalcOpContext';
import { getUserData } from 'queries/ossix/user/userData';
import React, { useEffect } from 'react';
import socketIOClient from './socketIO';

const BULK_PAYMENT_CALCULATION_IN_PROGRESS =
  'BulkPaymentCalculationInProgress';
const BULK_PAYMENT_CALCULATION_DONE = 'BulkPaymentCalculationDone';

interface BulkPaymentSocketProps {
  onCalculationInProgress?: (_message: string) => void;
  onCalculationDone?: (_response: any) => void;
}

const BulkPaymentSocket: React.FC<BulkPaymentSocketProps> = ({
  onCalculationInProgress,
  onCalculationDone,
}) => {
  const { setCalcOpInProgress } = useCalcOp();

  const { userData } = getUserData();

  const data = userData?.[0];

  useEffect(() => {
    if (data?.PID) {
      socketIOClient.off(BULK_PAYMENT_CALCULATION_IN_PROGRESS);
      socketIOClient.on(
        BULK_PAYMENT_CALCULATION_IN_PROGRESS,
        (notification: { message: string }) => {
          const { message } = notification || {};
          if (onCalculationInProgress) {
            onCalculationInProgress(message);
          }
        },
      );
    }

    return () => {
      socketIOClient.off(BULK_PAYMENT_CALCULATION_IN_PROGRESS);
    };
  }, [data?.PID, onCalculationInProgress]);

  useEffect(() => {
    if (data?.PID) {
      socketIOClient.off(BULK_PAYMENT_CALCULATION_DONE);
      socketIOClient.on(
        BULK_PAYMENT_CALCULATION_DONE,
        (calculatedData: any) => {
          if (onCalculationDone) {
            localStorage.removeItem('calcOpInProgress');
            setCalcOpInProgress(false);
            onCalculationDone(calculatedData);
          }
        },
      );
    }

    return () => {
      socketIOClient.off(BULK_PAYMENT_CALCULATION_DONE);
    };
  }, [data?.PID, onCalculationDone]);

  return null;
};

export default BulkPaymentSocket;
